import script from "./PptCoursewareCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./PptCoursewareCard.vue?vue&type=script&lang=ts&setup=true"

import "./PptCoursewareCard.vue?vue&type=style&index=0&id=3e860c82&scoped=true&lang=css"
import "./PptCoursewareCard.vue?vue&type=style&index=1&id=3e860c82&lang=less&scoped=true"
script.__scopeId = "data-v-3e860c82"

export default script